import React, { useEffect, useState } from "react";
import HomeHero from "../components/homepage-components/HomeHero";
import HomeIntro from "../components/homepage-components/HomeIntro";
import HomeServices from "../components/homepage-components/HomeServices";
import HomeValues from "../components/homepage-components/HomeValues";
import HomeReviews from "../components/homepage-components/HomeReviews";
import HomeGuides from "../components/homepage-components/HomeGuides";
import DiscountCode from "../components/popups/DiscountCode";
import Video from "../components/Video";
import { IoCloseSharp } from "react-icons/io5";
import { usePopupContext } from "../context-api/popup-context";

const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { catchUser, userClosedModal, setUserClosedModal } = usePopupContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const closeModal = () => {
    setUserClosedModal(true);
    setIsModalOpen(false);
  };

  /* useEffect(() => {
    window.scrollTo(0, 0);
    if (!catchUser && !userClosedModal) {
      setTimeout(() => {
        setIsModalOpen(true);
      }, 5000);
    }
  }, []); */

  return (
    <>
      <div className={isModalOpen ? "home-modal" : "hide"}>
        <button className="home-modal-close" onClick={closeModal}>
          <IoCloseSharp />
        </button>
        <DiscountCode setIsModalOpen={setIsModalOpen} />
      </div>
      <HomeHero />
      <HomeIntro />
      <Video />
      <HomeServices />
      <HomeValues />
      <HomeReviews />
      <HomeGuides />
    </>
  );
};

export default Home;
